import { render } from "./HomeRecommendPage.vue?vue&type=template&id=cc054ffc&ts=true"
import script from "./HomeRecommendPage.vue?vue&type=script&lang=ts"
export * from "./HomeRecommendPage.vue?vue&type=script&lang=ts"

import "./HomeRecommendPage.vue?vue&type=style&index=0&id=cc054ffc&lang=scss"

import exportComponent from "/home/smith/kitchenwebapp/kitchenwebapp/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__